module.exports = __webpack_public_path__ + "static/media/JB-Regular.a8ceff8b.otf";